import * as React from 'react'

const SvgHeart = props => (
  <svg width="1em" height="1em" viewBox="0 0 22 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 2.265C12.206.82 13.944-.006 15.768 0c3.276-.024 6.003 2.644 6.225 6.09.097 2.129-.7 4.194-2.178 5.648-1.719 1.907-7.564 7.617-7.814 7.86a1.442 1.442 0 01-1.998 0c-.27-.243-6.115-5.9-7.854-7.86C.685 10.277-.097 8.212.01 6.09.23 2.644 2.96-.024 6.235 0 8.059-.006 9.797.82 11 2.265zm9.483 3.962c-.138-2.635-2.213-4.693-4.716-4.678-2.506-.028-4.597 2.01-4.766 4.646-.17-2.636-2.26-4.674-4.766-4.646-2.504-.015-4.578 2.043-4.717 4.678-.073 1.68.564 3.309 1.74 4.446C5.005 12.56 11 18.47 11 18.47s6.045-5.91 7.744-7.797c1.175-1.137 1.812-2.765 1.738-4.446z"
      fill="#231815"
    />
    <mask
      id="Heart_svg__a"
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={22}
      height={20}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 2.265C12.206.82 13.944-.006 15.768 0c3.276-.024 6.003 2.644 6.225 6.09.097 2.129-.7 4.194-2.178 5.648-1.719 1.907-7.564 7.617-7.814 7.86a1.442 1.442 0 01-1.998 0c-.27-.243-6.115-5.9-7.854-7.86C.685 10.277-.097 8.212.01 6.09.23 2.644 2.96-.024 6.235 0 8.059-.006 9.797.82 11 2.265zm9.483 3.962c-.138-2.635-2.213-4.693-4.716-4.678-2.506-.028-4.597 2.01-4.766 4.646-.17-2.636-2.26-4.674-4.766-4.646-2.504-.015-4.578 2.043-4.717 4.678-.073 1.68.564 3.309 1.74 4.446C5.005 12.56 11 18.47 11 18.47s6.045-5.91 7.744-7.797c1.175-1.137 1.812-2.765 1.738-4.446z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#Heart_svg__a)">
      <path fill="#4F5B62" d="M0-2.105h22v23.158H0z" />
    </g>
  </svg>
)

export default SvgHeart
